import type {
  OpportunityAssessmentApiResponse,
  OpportunityAssessmentFollowUpActionApiResponse,
  OpportunityAssessmentParticipantApiResponse,
} from '../../features/opportunities/opportunity-wizard/steps/opportunity-assessment/opportunity-assessment-api/opportunity-assessment-api.models';
import { MOCK_DIRECTORY_USERS } from './users-api-mock.fixtures';

export const OA_MOCK_DEFAULT_PARTICIPANTS: OpportunityAssessmentParticipantApiResponse[] = [
  {
    user: MOCK_DIRECTORY_USERS[2],
    role: 'Bid lead',
  },
  {
    user: MOCK_DIRECTORY_USERS[3],
    role: 'SME',
  },
  {
    user: MOCK_DIRECTORY_USERS[4],
    role: 'Sales',
  },
];

export const OA_MOCK_FOLLOW_UP_ACTIONS: OpportunityAssessmentFollowUpActionApiResponse[] = [
  {
    description: 'Schedule pricing strategy session before bid commit',
    owner: MOCK_DIRECTORY_USERS[0],
    dueDateUtc: null,
  },
  {
    description: 'Confirm bid lead and SME staffing with Petra',
    owner: MOCK_DIRECTORY_USERS[1],
    dueDateUtc: null,
  },
  {
    description: 'Reach out to Insight references in retail vertical',
    owner: null,
    dueDateUtc: null,
  },
];

export function applyOpportunityAssessmentMockDefaults(
  assessment: OpportunityAssessmentApiResponse,
): OpportunityAssessmentApiResponse {
  return {
    ...assessment,
    areRisksAcknowledged: assessment.areRisksAcknowledged ?? false,
    participants:
      assessment.participants && assessment.participants.length > 0
        ? assessment.participants
        : [...OA_MOCK_DEFAULT_PARTICIPANTS],
    followUpActions:
      assessment.followUpActions && assessment.followUpActions.length > 0
        ? assessment.followUpActions
        : [...OA_MOCK_FOLLOW_UP_ACTIONS],
  };
}
